import { defineComponent as _defineComponent } from 'vue';
import { computed } from "vue";
import FileSourceTypeSpan from "@/components/FileSources/FileSourceTypeSpan.vue";
import ConfigurationMarkdown from "@/components/ObjectStore/ConfigurationMarkdown.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'TemplateSummary',
    props: {
        template: null
    },
    setup(__props) {
        const props = __props;
        const fileSourceType = computed(() => props.template.type);
        return { __sfc: true, props, fileSourceType, FileSourceTypeSpan, ConfigurationMarkdown };
    }
});
